import { UIText2 } from '@cian/ui-kit';
import { IconFunctionalClock16 } from '@cian/ui-kit-design-tokens/icons';
import React from 'react';

import * as styles from './EarlyAccessCounterBanner.css';

interface IEarlyAccessCounterBannerProps {
  text: string;
}

export function EarlyAccessCounterBanner({ text }: IEarlyAccessCounterBannerProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['icon']}>
        <IconFunctionalClock16 color="decorative-purple" />
      </div>
      <div className={styles['text']}>
        <UIText2>{text}</UIText2>
      </div>
    </div>
  );
}
